import React, { useCallback } from 'react';

import { areObjectsInsertable } from '../../../../store/selectors/insertableObjectsSelector';
import { clearRightClickedItems } from '../../../../store/slices/viewportSlice';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { AddItemMenu } from '../add-items/AddItemMenu';
import { SceneMenuContent } from '../common/SceneMenuContent';

// The menu to be shown when a right click occurs in empty space.
export function DefaultMenu() {
  const dispatch = useAppDispatch();
  const canInsert = useAppSelector(areObjectsInsertable);
  const onChooseItem = useCallback(() => void dispatch(clearRightClickedItems()), [dispatch]);

  if (!canInsert) return null;

  return (
    <SceneMenuContent>
      <AddItemMenu monitorText="Right click" onChooseItem={onChooseItem} />
    </SceneMenuContent>
  );
}
